import { vec3 } from "gl-matrix";
import { wHitRecord } from "./wHitRecord.js";
import { MathConst } from "./wContants.js";

class wTriangle {
    constructor(p0, p1, p2) {

        this.p0_ = vec3.create();
        this.p1_ = vec3.create();
        this.p2_ = vec3.create();

        vec3.copy(this.p0_, p0);
        vec3.copy(this.p1_, p1);
        vec3.copy(this.p2_, p2);
    }

    getPoints() {
        return [this.p0_, this.p1_, this.p2_];
    }

    rayIntersect(ray) {
        var hitRecord = new wHitRecord();
        let p1p0 = vec3.create();
        let p2p0 = vec3.create();
        let tVec = vec3.create();
        let pVec = vec3.create();

        vec3.subtract(p1p0, this.p1_, this.p0_);
        vec3.subtract(p2p0, this.p2_, this.p0_);
        vec3.subtract(tVec, ray.getOrigin(), this.p0_);
        vec3.cross(pVec, ray.getDirection(), p2p0);

        const det = vec3.dot(p1p0, pVec);

        if (Math.abs(det) < MathConst.fEps) {
            return hitRecord;
        }

        const invDet = 1.0 / det;
        const fU = vec3.dot(tVec, pVec) * invDet;

        if (fU < 0.0 || fU > 1.0) {
            return hitRecord;
        }

        let qVec = vec3.create();
        vec3.cross(qVec, tVec, p1p0);
        let fV = vec3.dot(ray.getDirection(), qVec) * invDet;

        if (fV < 0.0 || (fU + fV) > 1.0) {
            return hitRecord;
        }

        let t = vec3.dot(p2p0, qVec) * invDet;
        hitRecord.hitTimes_.push(t);
        hitRecord.validHit_ = true;
        return hitRecord;
    }

    translate(t) {
        this.p0_[0] += t[0];
        this.p0_[1] += t[1];
        this.p0_[2] += t[2];

        this.p1_[0] += t[0];
        this.p1_[1] += t[1];
        this.p1_[2] += t[2];

        this.p2_[0] += t[0];
        this.p2_[1] += t[1];
        this.p2_[2] += t[2];
    }
}

export { wTriangle };
